import { render, staticRenderFns } from "./Criacao.vue?vue&type=template&id=a53e6bc4&scoped=true&"
import script from "./Criacao.vue?vue&type=script&lang=js&"
export * from "./Criacao.vue?vue&type=script&lang=js&"
import style0 from "./Criacao.vue?vue&type=style&index=0&id=a53e6bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53e6bc4",
  null
  
)

export default component.exports